module.exports = {"version":"2.4","cennik":{"procent":"15","data":"2026-10-06"},"parameters":{"time_standby":"24","time_normal":"24","time_speech":"20","time_alarm":"10","battery_safety":"5","whoop":"30","anno":"70"},"glebokosc":{"value":["600"]},"zabezpieczenie":{"value":["16","20"]},"tryb_poboru":{"value":["normal","standby"]},"czas_podtrzymania":{"value":["6","24","72"]},"sieciowanie":{"value":["nie","tak"]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/config.json
// module id = 5377
// module chunks = 1